import * as React from "react";
import ReactDom from "react-dom";
import App from "./App";
import Wrapper from "./Wrapper";

ReactDom.render(<Wrapper />, document.getElementById("root"));
